<template>
  <div>
    <v-app class="p-4">

      <div class="col-md-8 mx-auto mt-25">
        <v-autocomplete outlined
                        label="نوع تنظیمات"
                        clear-icon="mdi-close-circle-outline"
                        prepend-inner-icon="fa fa-pencil-alt"
                        clearable
                        dense
                        v-model="chosenSetting"
                        :items="settingTypes"
                        item-text="name"
                        item-value="value">
        </v-autocomplete>
        <div v-if="chosenSetting === 'cafe' ">
          <v-text-field
              v-model="logNum"
              label="شماره تماس"
              required
              dense
              outlined
              counter="11"
              @keypress.enter="getLoginCode"
              class="mt-1"
              prepend-inner-icon="fa fa-pencil-alt"
          ></v-text-field>
          <v-btn class="btn-get-code" @click="getLoginCode">
            <span class="fa fa-save ml-1 mr-auto float-left" style="font-size: 1.5rem"></span>
            ارسال کد
          </v-btn>

          <v-otp-input v-if="EnterCode"
                       length="4"
                       class="col-md-3 mx-auto mt-0 pt-0"
                       plain
                       color="indigo"
                       v-model="code"
                       ref="confirmCode"
                       @finish="confirmation"
                       type="number"
          ></v-otp-input>
        </div>

      </div>
    </v-app>
  </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {Axios2} from "@/main";
import Vue from "vue";

export default {
  name: "systemSetting",
  components: {TitleRibbon},
  data() {
    return {
      settingTypes: [
        {name: 'تنظیمات کافه بازار', value: 'cafe'}
      ],
      logNum: '',
      EnterCode: false,
      chosenSetting: '',
      code: '',
      randomCode: undefined
    }
  },
  methods: {
    getLoginCode() {
      this.randomCode = crypto.randomUUID();

      Axios2.post('admin/bazaar/login', {phone: this.logNum, uniq: this.randomCode}).then((res) => {
        Vue.$toast.success('تا لحظاتی دیگر کد به شماره شما پیامک می شود.', {
          position: 'top'
        })
        this.EnterCode = true;
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.confirmCode.focus();
          }, 1000)
        });
      }).catch((err) => {
        this.$nextTick(() => {
          this.$modal.error('خطا!', Object.keys(err.response.data.errors).length > 0 ? err.response.data.errors.phone[0] : err.response.data.message)
        })
      })
    },
    confirmation() {
      Axios2.post('admin/bazaar/verify', {phone: this.logNum, code: this.code, uniq: this.randomCode}).then((res) => {
        this.$modal.success('موفقیت آمیز!', 'کد با موفقیت ثبت شد.');
        this.EnterCode = false;
        this.logNum = '';
        this.code = ''
      }).catch((err) => {
        this.$nextTick(() => {
          this.$modal.error('خطا!', err.response.data.errors.phone[0])
        })
      })
    }
  },
}
</script>

<style scoped>

</style>